document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById("wholesale-earning-potential-slider");
  const fill = document.querySelector(".wholesale-earning-potential-progress-fill");
  const thumb = document.querySelector(".wholesale-earning-potential-progress-thumb");

  function updateProgressBar() {
    const value = parseInt(slider.value, 10);
    const percent = (value / 2000) * 100;

    if (fill) fill.style.width = percent + "%";
    if (thumb) thumb.style.left = percent + "%";

    const customersEl = document.getElementById('wholesale-earning-potential-customers');
    const priceEl = document.getElementById('wholesale-earning-potential-price');
    const numberEl = document.getElementById('wholesale-earning-potential-number');

    if (customersEl) customersEl.textContent = value + " Customers";
    if (priceEl) priceEl.textContent = "$ " + (value * 600).toLocaleString();
    if (numberEl) numberEl.textContent = "Annually with " + value + " Customers";
  }

  if (slider) {
    slider.addEventListener("input", updateProgressBar);
    updateProgressBar();
  }
});
